module.exports = __webpack_public_path__ + "img/微信.20048f4d.png";